export const CABINET_INTERIOR_SECTION_TYPE = Object.freeze({
  shelf: 'shelf',
  box: 'box',
  drawer: 'drawer',
});
